var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0829 1.87659C10.0829 1.87664 10.083 1.87654 10.0829 1.87659L2.84693 9.12031L2.05051 11.9513L4.88507 11.1567L12.121 3.9121C12.1793 3.85387 12.2125 3.77445 12.2125 3.69212C12.2125 3.60987 12.1798 3.53098 12.1217 3.47276C12.1216 3.47271 12.1217 3.47282 12.1217 3.47276L10.5226 1.87664C10.4643 1.81843 10.3852 1.78568 10.3028 1.78568C10.2204 1.78568 10.1412 1.81847 10.0829 1.87659ZM9.24367 1.03813C9.52459 0.757658 9.90554 0.600098 10.3028 0.600098C10.6999 0.600098 11.0809 0.757638 11.3618 1.03808C11.3618 1.03806 11.3618 1.03809 11.3618 1.03808L12.9608 2.6342C13.2417 2.91476 13.3996 3.29541 13.3996 3.69212C13.3996 4.08883 13.2418 4.46929 12.961 4.74985L5.61556 12.104C5.54348 12.1762 5.454 12.2286 5.35574 12.2561L1.35356 13.378C1.14695 13.4359 0.925132 13.378 0.773412 13.2264C0.621692 13.0748 0.563704 12.8533 0.62175 12.6469L1.74598 8.65076C1.77344 8.55315 1.82551 8.46421 1.89721 8.39243L9.24367 1.03813Z",
    fill: "#5A6385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.fa6687fa69bec53fabd7249739826d53.svg";
export { ForwardRef as ReactComponent };